import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from "redux-persist";
import { composeWithDevTools } from 'redux-devtools-extension';
import storage from "redux-persist/lib/storage";

import reducers from './ducks';
import rootSaga from "./sagas";

/**
 * Indice dos Ducks e Sagas
 * @author Fábio Sartori
 * @copyright 06/2019
 */
const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
    key: "root",
    storage,
    whitelist: ['authorization', 'authentication', 'language']
};

let midCompose = "";

if (process.env.NODE_ENV === "development") {
    midCompose = composeWithDevTools(
        applyMiddleware(sagaMiddleware)
        );
    } else {
    midCompose = applyMiddleware(sagaMiddleware);
}

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer, midCompose);
const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor } ;